export default __webpack_public_path__ + "static/media/home.12b4800a.svg";